import React from 'react'

export default function SupportChat({initialState, onDataChanged}) {
    const isCustomPopupPositionEnabled = initialState?.customize_popup_position == "true" || initialState?.customize_popup_position == true

    return <div>
        <h5 className="hotspot-setting-header">Support Chat</h5>
        <hr/>
        <div className="form-group form-check mt-2">
            <input type="checkbox"
                   className="form-check-input"
                   checked={initialState?.showInitially == "true" || initialState?.showInitially == true}
                   onChange={(event) => {
                       onDataChanged({
                           ...initialState,
                           showInitially: event.target.checked
                       })
                   }}
            />
            <label htmlFor="" className="form-check-label">
                Show the chat initially.
            </label>
        </div>
        <hr/>
        <div className="form-group form-check mt-2">
            <input type="checkbox"
                   className="form-check-input"
                   checked={isCustomPopupPositionEnabled}
                   onChange={(event) => {
                       onDataChanged({
                           ...initialState,
                           customize_popup_position: event.target.checked
                       })
                   }}
            />
            <label htmlFor="" className="form-check-label">
                Enables custom positioning of the popup.
            </label>
        </div>

        {isCustomPopupPositionEnabled && <div className="form-group">
            <label htmlFor="hotspotPosition">Popup Position</label>
            <select className="form-control"
                    id="hotspotPosition"
                    value={initialState?.popup_position}
                    onChange={(event) => {
                        onDataChanged({
                            ...initialState,
                            popup_position: event.target.value
                        })
                    }}>
                <option value="top-left">Top Left</option>
                <option value="top-right">Top Right</option>
                <option value="bottom-left">Bottom Left</option>1
                <option value="bottom-right">Bottom Right</option>
            </select>
            <small id="hotspotPositionHelpBlock" className="form-text text-muted">
                By changing this you specify the position of the popup.
            </small>
        </div>}
    </div>
}
